export default "__VITE_ASSET__bdb4888c__"